module.exports = __webpack_public_path__ + "static/img/1.d8da66a3.png";